export enum ACCOUNT_TYPE {
  CONTA_CORRENTE_PESSOA_FISICA = 1,
  CONTA_CORRENTE_PESSOA_JURIDICA = 2,
  CONTA_POUPANCA_PESSOA_FISICA = 3,
  CARTAO_MAGNETICO = 4,
  CONTA_PAGAMENTO_PESSOA_FISICA = 5,
}

export enum ATTACHMENT_TYPE {
  CCB = 1,
  DOCUMENTO_FRENTE = 2,
  DOCUMENTO_VERSO = 3,
  SELFIE = 4,
  FOTO_PROVA_DE_VIDA = 5,
  COMPROVANTE_DE_ENDERECO = 6,
  COMPROVANTE_FINANCEIRO = 7,
  CNH = 8,
  REPASSE = 11,
  DOCUMENTOS_ADICIONAIS = 12,
  FRENTE_CNH = 13,
  VERSO_CNH = 14,
  TERMO_E_ASSINATURAS = 15,
  CONTRACHEQUE = 16,
  DOCUMENTO_ASSINADO_FISICAMENTE = 17,
  DOCUMENTO_FRENTE_ROGADO = 18,
  DOCUMENTO_VERSO_ROGADO = 19,
  CNH_ROGADO = 20,
  DOCUMENTO_FRENTE_TESTEMUNHA_1 = 9,
  DOCUMENTO_VERSO_TESTEMUNHA_1 = 10,
  CNH_TESTEMUNHA_1 = 21,
  DOCUMENTO_FRENTE_TESTEMUNHA_2 = 23,
  DOCUMENTO_VERSO_TESTEMUNHA_2 = 24,
  CNH_TESTEMUNHA_2 = 25,
  ARQUIVO_RETORNO_RESERVA = 22,
  DOCUMENTO_ASSINADO_FISICAMENTE_PORTABILIDADE = 26,
  DOCUMENTO_ASSINADO_FISICAMENTE_REFINANCIAMENTO = 27,
  DOCUMENTO_FRENTE_REPRESENTANTE_LEGAL = 28,
  DOCUMENTO_VERSO_REPRESENTANTE_LEGAL = 29,
  CNH_REPRESENTANTE_LEGAL = 30,
  SELFIE_REFORMALIZACAO = 31,
  EXTRATO_BANCARIO = 35,
  HISTORICO_DEBITO_CONVENIO = 36,
  COMPROVANTE_RENDA = 37,
}

export enum ATTACHMENT_SUBTYPE {
  TERMO_CCB = 1,
  TERMO_ADESAO = 2,
  TERMO_CONSENTIMENTO = 3,
  TERMO_AUTORIZACAO_INSS = 4,
  TERMO_SEGURO_PRATA = 5,
  TERMO_SEGURO_OURO = 6,
  TERMO_SEGURO_DIAMANTE = 7,
  TERMO_REGULAMENTO = 8,
}

export enum CONTRACT_STATUS {
  DIGITACAO = 1,
  AGUARDANDO_FORMALIZACAO = 2,
  FORMALIZADO = 3,
  MESA = 4,
  EM_AVERBACAO = 5,
  PAGO = 6,
  CANCELADO = 0,
}

export enum CONTRACT_TYPE {
  OPERACAO_NOVA = 1,
  REFINANCIAMENTO = 2,
  REFIN_PORTABILIDADE = 3,
  PORTABILIDADE = 4,
  NOVO_AUMENTO_SALARIAL = 5,
  RECEBA = 8,
}

export enum CORBAN_ACTION {
  APROVAR = 1,
  RECUSAR = 2,
  PENDENCIAR = 3,
}

export enum DOCUMENT_TYPE {
  RG = 1,
  CNH = 2,
  OUTROS = 3,
}

export enum PRODUCT_CODE {
  MARGEM_LIVRE = "540",
  CARTAO_BENEFICIO = "001",
  PORTABILIDADE = "002",
  SAQUE_COMPLEMENTAR = "003",
  PORTABILIDADE_REFIN = "004",
  CARTAO_CONSIGNADO = "005",
  REFINANCIAMENTO = "006",
  MARGEM_LIVRE_AUMENTO = "007",
  REFIN_SAQUE_CARTAO = "009",
  AGREGACAO_MARGEM_CARTAO = "010",
  RECEBA = "23",
  CONSIGNADO_PRIVADO = "024",
}

export enum OPERATION_TYPE {
  COMPRA = 1,
  DESEMBOLSO = 2,
}

export enum PRODUCT_STATUS {
  // CARTAO_BENEFICIO
  ANDAMENTO_SIMULACAO = 1,
  ANDAMENTO_FORMALIZACAO = 5,
  APROVADA_FINALIZADA = 6,
  REPROVADA_FINALIZADA = 7,
  CHECAGEM_MESA_FORMALIZACAO = 8,
  APROVADA_MESA_FORMALIZACAO = 9,
  REPROVADA_MESA_FORMALIZACAO = 10,
  PENDENTE_DOCUMENTACAO = 11,
  EM_AVERBACAO = 12,
  APROVADA_AVERBACAO = 13,
  RECUSADA_AVERBACAO = 14,
  ANDAMENTO_EMISSAO_CARTAO = 15,
  FINALIZADA_EMISSAO_CARTAO = 16,
  ANDAMENTO_LIBERACAO_SAQUE = 17,
  FINALIZADA_LIBERACAO_SAQUE = 18,
  PENDENTE_CORRECAO_DADOS_BANCARIOS = 19,

  // PORTABILIDADE
  AGUARDA_ENVIO_LINK = 20,
  FORMALIZACAO_CLIENTE = 21,
  ANALISE_DE_CREDITO = 22,
  PENDENTE_DADOS_DIVERGENTES = 23,
  REPROVADA_POLITICA_INTERNA = 24,
  CHECAGEM_MESA_CORBAN = 25,
  PENDENTE_DOCUMENTACAO_MESA_CORBAN = 26,
  REPROVADA_MESA_CORBAN = 27,
  APROVADA_MESA_CORBAN = 28,
  CHECAGEM_MESA_DE_FORMALIZACAO = 29,
  APROVADA_MESA_DE_FORMALIZACAO = 30,
  REPROVADA_MESA_DE_FORMALIZACAO = 31,
  AGUARDA_RETORNO_SALDO = 32,
  SALDO_RETORNADO = 33,
  INT_CONFIRMA_PAGAMENTO = 34,
  SALDO_REPROVADO = 35,
  REPROVADA_PAGAMENTO_DEVOLVIDO = 36,
  INT_AGUARDA_AVERBACAO = 37,
  INT_FINALIZADO = 38,
  INT_AVERBACAO_PENDENTE = 39,

  // CARTAO NOVOS
  ERRO_SOLICITACAO_SAQUE = 40,

  // PORTABILIDADE IN100
  REPROVADO = 41,
  AGUARDANDO_RETORNO_IN100 = 42,

  // NOVO STATUS
  AGUARDANDO_IN100_RECALCULO = 43,
  RETORNO_IN100_RECALCULO_RECEBIDO = 44,

  REVISAO_MESA_DE_FORMALIZACAO = 45,
  REPROVADA_REVISAO_MESA_DE_FORMALIZACAO = 46,
  AVERBACAO_MESA_DE_FORMALIZACAO = 47,

  SAQUE_CANCELADO_LIMITE_DISPONIVEL_INSUFICIENTE = 48,
  SAQUE_RECUSADO_PROBLEMA_PAGAMENTO = 49,

  ANDAMENTO_REAPRESENTACAO_DO_PAGAMENTO_DE_SAQUE = 50,
  PENDENCIADO = 51,

  ANDAMENTO_CHECAGEM_DATAPREV = 52,
  ERRO_CONSULTA_DATAPREV = 53,
  REPROVADO_CONSULTA_DATAPREV = 54,

  // PORT + REFIN
  AGUARDANDO_AVERBACAO_REFIN = 55,
  AGUARDANDO_DESEMBOLSO_REFIN = 56,
  AGUARDANDO_FINALIZAR_PORT = 57,
  INT_FINALIZADO_DO_REFIN = 58,

  ERRO_CRIACAO_CARTAO = 59,
  PENDENTE_APROVACAO_RECALCULO_CORBAN = 60,

  CHECAGEM_MESA_DE_AVERBECAO = 61,

  AGUARDA_FINALIZACAO_PROPOSTA_PRINCIPAL = 62,
  REPROVADA_MESA_DE_AVERBECAO = 63,
  INT_AJUSTE_AVERBACAO = 64,

  VALIDACOES_AUTOMATICAS = 65,
  AGUARDANDO_DESEMBOLSO = 66,
  INT_AGUARDANDO_PAGO_QITECH = 67,

  PENDENCIAS_AVERBACAO_CORBAN = 68,
  REGULARIZADA_MESA_AVERBACAO = 69,
  FINALIZADA_FORMALIZACAO_CLIENTE = 70,
  FINALIZADA_FORMALIZACAO_ROGADO = 71,

  AGUARDANDO_FIM_MACICA = 72,
  CHECAGEM_MESA_VIDEO = 73,

  TEIMOSINHA_DATAPREV = 74,

  APROVADA_VIDEO_CHAMADA = 85,
  REPROVADO_VIDEO_CHAMADA = 75,
  PENDENCIADO_VIDEO_CHAMADA = 76,

  CHECAGEM_AVERBACAO_CONECTA = 80,
  APROVADA_AVERBACAO_CONECTA = 81,
  PENDENCIADO_AVERBACAO_CONECTA = 82,
  REGULARIZADA_AVERBACAO_CONECTA = 83,
  REPROVADO_AVERBACAO_CONECTA = 84,
  APROVADO_PRICING = 88,
  RECALCULO_PRICING = 89,
  RECALCULO_REFINANCIAMENTO = 90,

  // REFORMALIZAÇÃO
  REFORMALIZACAO_CLIENTE = 91,
  PROPOSTA_CANCELADA_PELO_CORBAN = 92,
  APROVADO_REFORMALIZACAO = 93,
  APROVADO_AUTOMATICAMENTE_MESA_FORMALIZACAO = 94,

  TAXA_COMISSAO_COBYX_REALIZADA = 95,
  ERRO_TAXA_COMISSAO_COBYX = 96,
  CHECAGEM_MESA_SALDO = 97,
  RECUSADA_AVERBACAO_SIAPE = 98,
  RECUSADA_AVERBACAO_CLIENTE = 99,
  AGUARDANDO_ACEITE_CLIENTE_AVERBACAO = 100,

  // CANCELAMENTO DE PROPOSTA
  CANCELADO = 101,
  ANDAMENTO_ANALISE_OPERACIONAL = 102,

  ANALISE_TECNICA = 103,
  PENDENTE_VALIDACAO_PARCELA = 104,
  PARCELA_AJUSTADA = 105,
  FINALIZADO_LIQUIDACAO_SAQUE = 106,
  PROPOSTA_REPRESADA = 107,

  // AGREGACAO DE MARGEM CARTAO
  EM_ANDAMENTO_ALTERACAO_LIMITE = 113,
  FINALIZADO_ALTERACAO_LIMITE = 114,
  REPROVADO_ALTERACAO_LIMITE = 115,

  // RECEBA
  AGUARDANDO_VALIDACAO_CORBAN = 116,
  AGUARDANDO_ARQUIVO_OPTANTE = 117,
  REPORVADO_RECALCULO_SCD = 118,
  ARQUIVO_OPTANTE_RETORNADO = 119,
  APROVADO_RECALCULO_SCD = 120,
  TEIMOSINHA_IN100 = 122,
  TEIMOSINHA_IN100_ENVIADO = 123,

  // AUMENTO DE MARGEM
  AGUARDANDO_AVERBACAO_AUMENTO_MARGEM = 124,
  DIGITACAO = 125,
  GERACAO_PROPOSTA = 127,

  REFIN_CANCELADO = 128,
  AGUARDANDO_IN100_FURAFILA = 129,
  AGUARDANDO_ENVIO_SALDO_REPRESADO = 130,
  AVERBADO_AGUARDANDO_ANUENCIA = 131,
}

export enum PRODUCT_TYPE {
  TODOS_PRODUTOS = 0,
  FGTS = 1,
  INSS_REPRESENTANTE_LEGAL = 2,
  CARTAO_BENEFICIO_REPRESENTANTE = 3,
  PAB = 4,
  INSS_CORBAN = 5,
  INSS = 6,
  CARTAO_BENEFICIO = 7,
  SIAPE = 8,
  EXERCITO = 9,
  MARINHA = 10,
  AERONAUTICA = 11,
  PORTABILIDADE = 12,
  CONSIGNADO = 13,
  SAQUE_COMPLEMENTAR = 14,
  CARTAO_CONSIGNADO = 15,
  MARGEM_LIVRE = 16,
  PORTABILIDADE_REFIN = 17,
  REFINANCIAMENTO = 18,
  MARGEM_LIVRE_AUMENTO = 20,
  REFIN_CARTAO = 21,
  AGREGACAO_MARGEM = 22,
  RECEBA = 23,
  CONSIGNADO_PRIVADO = 24,
}

export enum QI_STATUS {
  PENDING_SUBIMISSION = 0,
  PENDING_RESPONSE = 1,
  PENDING_ACCEPTANCE = 2,
  ACCEPTED = 3,
  CANCELED = 4,
  RETAINED = 5,
  SETTLEMENT_SENT = 6,
  PENDING_SETTLEMENT_CONFIRMATION = 7,
  PAID = 8,
  REJECTED = 9,
  SIGNATURE_RECEIVED = 10,
  COLLATERAL = 11,
}

export enum CLIENT_TYPE {
  HAPPY = "happy",
  CAIXA = "caixa",
  BANESE = "banese",
  BRB = "brb",
  RECEBA = "receba",
  SEUCREDITO = "seucredito",
  ZILICRED = "zilicred",
  UNKNOWN = "unknown",
  LOCALHOST = "localhost",
}

export enum BENEFIT_CARD_WITHDRAWAL_TYPE {
  SEM_SAQUE = 0,
  A_VISTA = 1,
  PARCELADO = 2,
}

export enum BENEFIT_CARD_AUTORIZATION_TYPE {
  AUTOATENDIMENTO = 1,
  AGENCIA = 2,
  DIGITAL_VIA_CLIENTE = 3,
  DIGITAL_VIA_CORRESPONDENTE = 4,
  MOBILE = 5,
}

export enum BENEFIT_CARD_IN100_TYPE_ACCOUNT {
  CONTA_CORRENTE = 2,
}

export enum CONTRACTS_REPORT_TYPE {
  GERAL = "geral",
  DIGITACAO = "digitacao",
  FINALIZACAO = "finalizacao",
  SALDO_PORTABILIDADE = "saldo-retornado",
}

/**
 * 1 - Ativo, 2 - Pendente, 3 - Recusado
 */
export enum INSURANCE_STATUS {
  ATIVO = 1,
  PENDENTE = 2,
  RECUSADO = 3,
}

export enum PLANS_TYPE {
  PRATA = 1,
  OURO = 2,
  DIAMANTE = 3,
}

export enum MARGIN_TYPE {
  MARGEM_COMPRA = 1,
  MARGEM_SAQUE = 2,
  MARGEM_UNICA = 3,
  MARGEM_UNIFICADA = 4,
}

export enum AVERBADORAS {
  FACIL = 1,
  ZETRASOFT = 2,
  QUANTUM = 3,
  DATAPREV_BRB = 4,
  DATAPREV_PINE = 5,
  SERPRO = 6,
  NEOCONSIG = 7,
}

export enum HIERARCHY_LEVEL {
  ADMINISTRADOR = 5,
  DONO_LOJA = 4,
  GERENTE = 3,
  SUPERVISOR = 2,
  DIGITADOR = 1,
}

export enum REGISTRATION_PENDENCY_TYPE {
  SENHA_DE_AVERBACAO = 1,
  CONTRACHEQUE = 2,
  DEMAIS_ANEXOS_DE_AVERBACAO = 3,
}

export enum EDUCATION_LEVEL {
  FUNDAMENTAL = 1,
  MEDIO = 2,
  SUPERIOR = 3,
  POS_GRADUADO = 4,
  ANALFABETO = 5,
}

export enum KINSHIP_LEVEL {
  PAI = 1,
  MAE = 2,
  FILHO = 3,
  CONJUGE = 4,
  IRMAO = 5,
}

export enum CALL_LOG_TYPE {
  CONNECTED = "connected",
  DISCONNECTED = "disconnected",
  STARTED_RECORD = "started_record",
  FINALIZED_BY_ATTENDANT = "finalized_by_attendant",
}

export enum CHANNELS {
  WEBSITE = "Website",
}

export enum SIAPE_BOND_TYPE {
  SERVIDOR = 1,
  PENSIONISTA = 2,
}

export enum RETENTION_STATUS {
  EM_RETENCAO = 0,
  RETENCAO_RECEBIDA = 1,
  RETENCAO_ENVIADA = 2,
  RETIDO = 4,
}

export enum FOLLOW_RETENTION_STATUS {
  SEM_RETENCAO = 0,
  RETENCAO_RECEBIDA = 1,
  RETENCAO_ENVIADA = 2,
  AGUARDANDO_VALIDACAO = 3,
  CANCELADO_PELO_PROPONENTE = 4,
  CANCELADO_PELO_CREDOR = 5,
  RETIDO = 6,
}

export enum REASON_CONTRACT_CANCELATION {
  DESISTENCIA_CLIENTE = 1,
  FORMALIZACAO_EXPIRADA = 2,
}

export enum PRESTAMISTA_STATUS {
  PENDENTE = 1,
  CONCLUIDO = 2,
  CANCELADO = 3,
  APROVADO_FORMALIZACAO = 4,
  REMOVIDO_FORMALIZACAO = 5,
}

export enum DUE_DATE_RULE {
  reverse_fifth_business_day = "reverse_fifth_business_day",
  reverse_fourth_business_day = "reverse_fourth_business_day",
  reverse_third_business_day = "reverse_third_business_day",
  reverse_second_business_day = "reverse_second_business_day",
  reverse_first_business_day = "reverse_first_business_day",
  first_business_day = "first_business_day",
  second_business_day = "second_business_day",
  third_business_day = "third_business_day",
  fourth_business_day = "fourth_business_day",
  fifth_business_day = "fifth_business_day",
}

export enum LINKED_REGISTER {
  LINK_VINCULO_GERADO = "Link de vínculo gerado",
  FORMALIZADO = "Formalizado",
  CHECAGEM_MESA = "Checagem Mesa",
  APROVADO_VALIDACAO_FACIAL = "Aprovado validação facial",
  APROVADO_MESA = "Aprovado Mesa",
  REPROVADO_VALIDACAO_FACIAL = "Reprovado validação facial",
  REPROVADO_MESA = "Reprovado Mesa",
}

export enum USER_GROUPS {
  MESA_RETENCAO = 34,
  MESA_RETENCAO_CORBAN = 44,
}

export enum RETENTION_OBJECTIVE {
  ABAIXO_DO_OBJETIVO = "0",
  ACIMA_DO_OBJETIVO = "1",
}
